import { timestamp } from './timestamp';
import { fieldMask } from './field-mask';
import { bytes } from './bytes';
import { duration } from './duration';
import { float } from './float';
export const protobufConverters = [
    timestamp,
    fieldMask,
    bytes,
    duration,
    float,
];
//# sourceMappingURL=converters.js.map